import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Select, Space } from "antd";
import React, { useRef, useState } from "react";
import styles from "./styles.module.css";

interface DivisionSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  divisions: string[];
}

let index = 0;

const DivisionSelector: React.FC<DivisionSelectorProps> = ({
  value,
  onChange,
  divisions = [],
}) => {
  const [items, setItems] = useState(divisions);
  const [name, setName] = useState("");
  const inputRef = useRef<React.ElementRef<typeof Input>>(null);
  const originalDivisions = new Set(divisions);

  const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const addItem = (e?: React.MouseEvent<HTMLElement>) => {
    e?.preventDefault();
    const newItem = name.trim() || `New division ${index++}`;
    if (newItem && !items.includes(newItem)) {
      setItems([...items, newItem]);
      setName("");
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      addItem();
    }
  };

  const removeItem = (itemToRemove: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setItems(items.filter((item) => item !== itemToRemove));
    if (value === itemToRemove) {
      onChange?.("");
    }
  };

  return (
    <Select
      allowClear
      showSearch
      filterOption={(input, option) =>
        (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
      }
      className={styles["division-selector"]}
      placeholder="Select division"
      value={value}
      onChange={onChange}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <Space className={styles["division-dropdown-space"]}>
            <Input
              placeholder="Add division"
              ref={inputRef}
              value={name}
              onChange={onNameChange}
              onKeyDown={handleKeyDown}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
              Add division
            </Button>
          </Space>
        </>
      )}
      options={items.map((item) => ({
        label: (
          <div className={styles["division-option-container"]}>
            <span>{item}</span>
            {!originalDivisions.has(item) && (
              <DeleteOutlined
                className={styles["division-delete-icon"]}
                onClick={(e) => removeItem(item, e)}
              />
            )}
          </div>
        ),
        value: item,
      }))}
    />
  );
};

export default DivisionSelector;
